import { render, staticRenderFns } from "./SoalMapel.vue?vue&type=template&id=41c91f89&scoped=true"
import script from "./SoalMapel.vue?vue&type=script&lang=js"
export * from "./SoalMapel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c91f89",
  null
  
)

export default component.exports